import { PortalHost } from '@gorhom/portal';
import React from 'react';

interface AbsoluteHostProps {
  name: string;
}

/**
 * This host will render the screen passed in the `Absolute` component and should be placed in the
 * DOM location where the component should be rendered
 */
export const AbsoluteHost: React.FC<AbsoluteHostProps> = ({ name }) => <PortalHost name={name} />;
